import { Phone, Mail, MapPin, Clock3 } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_ad37d109-0510-49cf-8bc7-b236afa36719/artifacts/2a2b75d6da9fff77_file_00000000b8448210b1d7027daea590bc.png";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] bg-[#060608] pb-28 pt-16" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <img src={LOGO_URL} alt="Redemption Restoration logo" className="w-36" data-testid="footer-logo" />
            <p className="font-serif-display mt-5 text-lg italic text-purple-300">
              Restoring Properties. Rebuilding Lives.
            </p>
          </div>
          <div>
            <p className="font-mono-data mb-5 text-[10px] uppercase tracking-[0.3em] text-slate-500">Contact</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href="tel:9204152145"
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 text-slate-300 transition-colors hover:text-purple-300"
                >
                  <Phone className="h-4 w-4 text-purple-400" /> 920-415-2145
                </a>
              </li>
              <li>
                <a
                  href="mailto:redemptionrestoration920@gmail.com"
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 break-all text-slate-300 transition-colors hover:text-purple-300"
                >
                  <Mail className="h-4 w-4 shrink-0 text-purple-400" /> redemptionrestoration920@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <MapPin className="h-4 w-4 text-purple-400" /> Fox Valley, Wisconsin &amp; Beyond
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono-data mb-5 text-[10px] uppercase tracking-[0.3em] text-slate-500">Services</p>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li>Water Damage Restoration</li>
              <li>Fire &amp; Smoke Restoration</li>
              <li>Mold Remediation</li>
              <li>Sewage Cleanup</li>
              <li>Biohazard &amp; Trauma Cleanup</li>
              <li>Full Home Rebuild</li>
            </ul>
            <p className="font-mono-data mt-6 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-purple-300">
              <Clock3 className="h-3.5 w-3.5" /> Open 24 Hours · 7 Days
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 sm:flex-row">
          <p className="font-mono-data text-[10px] uppercase tracking-[0.25em] text-slate-600">
            © {new Date().getFullYear()} Redemption Restoration
          </p>
          <p className="font-mono-data text-[10px] uppercase tracking-[0.25em] text-slate-600">
            Emergency? <a href="tel:9204152145" className="text-purple-400 hover:text-purple-300">Call 920-415-2145</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
